<template>
    <div class="collection-list-container">
        <div class="box">
            <button class='button is-primary' @click="onAdd">新增单品合集</button>
            <el-upload
                    class="banner-uploader"
                    :action="server"
                    :show-file-list="false"
                    name="image"
                    :on-success="handleTopBanner"
                    :before-upload="beforeUpload">
                <div class="info">
                    <el-button class="floatl" size="small" type="success">上传顶部banner</el-button>
                </div>
            </el-upload>
            <el-popover
                    ref="popover4"
                    placement="right"
                    width="400"
                    trigger="click">
                <div>
                    <image-component :image="topBannerImage" :width="300"></image-component>
                </div>
            </el-popover>
            <button class="button" v-popover:popover4>查看</button>
        </div>
        <div>
            <a href="http://image3.ichuanyi.cn/group2/M00/33/F9/CgAANVrUHlsEAAAAAAAAAO6fwJw211.jpg" target="_blank" class="button is-info">查看小程序二维码</a>
        </div>
        <div class="list-wrap">
            <div class="clearfix">
                <el-pagination
                        v-if="count>0"
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="is-parent clearfix flex">
                <table class="table is-bordered">
                    <thead>
                    <tr>
                        <th>标题</th>
                        <th>关联单品卡片</th>
                        <th>图片</th>
                        <th>开放时间</th>
                        <th>banner点击次数</th>
                        <th>进入次数</th>
                        <th>销量</th>
                        <th>GMV</th>
                        <th>转化率</th>
                        <th>利润</th>
                        <th>排序</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list">
                            <td>{{item.title}}</td>
                            <td>
                                <p>卡片ID：<a :href="platform + '/m/page/card/goods/?type=2&cardId='+item.card.cardId" target="_blank">{{item.card.cardId}}</a></p>
                                <p>【{{item.card.name}}】</p>
                            </td>
                            <td>
                                <a :href="platform + '/m/page/card/goods/?type=2&cardId='+item.card.cardId" target="_blank">
                                    <image-component :image="item.image" :width="160"></image-component>
                                </a>
                            </td>
                            <td>
                                <p>{{item.startTimeStr}} ~ {{item.endTimeStr}}</p>
                                <el-tag v-if="item.showStatus == SHOWING" type="success">展示中</el-tag>
                                <el-tag v-if="item.showStatus == FUTURE_SHOW" >即将展示</el-tag>
                                <el-tag v-if="item.showStatus == CLOSE" type="info">已关闭</el-tag>
                            </td>
                            <td>{{item.bannerClickNum}}</td>
                            <td>{{item.accessNum}}</td>
                            <td>{{item.saleCount}}</td>
                            <td>￥{{item.saleGvm}}</td>
                            <td>{{item.conversionRate}}</td>
                            <td>￥{{item.profit}}</td>
                            <td>
                                <input type="number" class="input" v-model="item.sort" @blur="onBlur(index)">
                            </td>
                            <td>
                                <button class="button is-info" @click="onEdit(index)">编辑</button>
                                <button class="button is-danger" @click="onRemove(item.mpGoodsCollectionId)">删除</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="clearfix">
                <el-pagination
                        v-if="count>0"
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="" :visible="modal.visible" :lock-scroll='false' :close-on-click-modal="false" :show-close="false">
            <el-form label-position="left" label-width="120px" :model="modal.form">
                <el-form-item label="标题">
                    <el-input v-model="modal.form.title" style="max-width: 300px;"></el-input>
                    <label class="label inline-block">注：此标题将作为小程序内单品卡片页的分享文案！</label>
                </el-form-item>
                <el-form-item label="展示时间">
                    <el-date-picker
                            v-model="modal.form.startTime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始时间">
                    </el-date-picker>
                    <span class="r-top">~</span>
                    <el-date-picker
                            v-model="modal.form.endTime"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="单品数据卡片ID">
                    <el-input v-model="modal.form.cardId" style="max-width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="排序号">
                    <el-input v-model="modal.form.sort" style="max-width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="单品合集banner">
                    <el-upload
                            class="banner-uploader"
                            :action="server"
                            :show-file-list="false"
                            name="image"
                            :on-success="handleBanner"
                            :before-upload="beforeUpload">
                        <div class="info">
                            <el-button class="floatl" size="small" type="success">上传banner</el-button>
                            <label class="label inline-block">建议尺寸：686*340</label>
                        </div>
                    </el-upload>
                    <image-component v-if="modal.form.bannerImage" :image="modal.form.bannerImage"
                                     :width="400"></image-component>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onCancel">取 消</el-button>
                <el-button type="primary" @click="onConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
// 已关闭

import { formatDate } from 'UTILS/date'; const SHOWING = 1 // 展示中
const FUTURE_SHOW = 2 // 即将展示
const CLOSE = 0

export default {
  components: {},
  data () {
	  return {
      list: [],
      search: {
		  page: 1,
		  pageSize: 20
      },
      count: 0,
      topBanner: {},
      modal: {
		  visible: false,
		  mpGoodsCollectionId: '',
		  form: {
          title: '',
          startTime: '',
          endTime: '',
          cardId: '',
          bannerImage: '',
          sort: ''
		  }
      },
      platform: process.env.VUE_APP_PLATFORM,
      SHOWING: SHOWING,
      FUTURE_SHOW: FUTURE_SHOW,
      CLOSE: CLOSE
	  }
  },
  mounted () {
	  this.getList()
    this.getTopBanner()
  },
  computed: {
	  server () {
      return process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage'
	  },
	  topBannerImage () {
      return this.topBanner.image
	  }
  },
  methods: {
	  getTopBanner () {
	    HttpRequest.get('/admin.php?method=banner.getMiniProgramSelect').then(response => {
	      this.topBanner = {
          image: response.data.banner.image.path,
          width: response.data.banner.image.width,
          height: response.data.banner.image.height
        }
      })
    },
	  getList () {
      HttpRequest.get('/admin.php?method=mpgoodscollection.getList', this.search).then(response => {
		  this.list = _.toArray(response.data.list)
        this.count = response.data.count
        this.formatData()
      })
	  },
	  formatData () {
	    let now = parseInt(+new Date() / 1000)
	    _.each(this.list, item => {
        if (item.startTime < now && item.endTime > now) {
          item.showStatus = this.SHOWING
        } else if (item.endTime < now) {
          item.showStatus = this.CLOSE
        } else if (item.startTime > now) {
          item.showStatus = this.FUTURE_SHOW
        }
		  item.startTimeStr = formatDate(item.startTime, 'yyyy-MM-dd hh:mm:ss')
		  item.endTimeStr = formatDate(item.endTime, 'yyyy-MM-dd hh:mm:ss')
      })
    },
	  handleTopBanner (response, file) {
      this.topBanner = {
		  image: response.data.images.info.path,
		  width: response.data.images.info.width,
		  height: response.data.images.info.height
      }
      HttpRequest.post('/admin.php?method=banner.setMiniProgramSelect', {image: this.topBanner.image}).then(response => {
		  if (response.data.success) {
		    this.$message('图片上传成功')
        }
      })
	  },
	  handleBanner (response, file) {
      this.modal.form.bannerImage = response.data.images.info.path
	  },
	  beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/gif'
      const isLt2M = file.size / 1024 < 1024

      if (!isJPG) {
		  this.$message('上传图片只能是 JPG/PNG/GIF 格式!')
      }
      if (!isLt2M) {
		  this.$message('上传图片大小不能超过 1M!')
      }
      return isJPG && isLt2M
	  },
	  handleCurrentChange (value) {
      if (this.search.page !== value) {
		  this.search.page = value
		  this.getList()
      }
	  },
	  onEdit (index) {
	    this.modal.mpGoodsCollectionId = this.list[index].mpGoodsCollectionId
      this.modal.form = {
		  title: this.list[index].title,
		  startTime: this.list[index].startTimeStr,
		  endTime: this.list[index].endTimeStr,
		  cardId: this.list[index].card.cardId,
		  bannerImage: this.list[index].image.path,
		  sort: this.list[index].sort
      }
      this.modal.visible = true
	  },
	  onRemove (id) {
	    if (!confirm('确定删除？')) return false
	    HttpRequest.post('/admin.php?method=mpgoodscollection.doRemove', {mpGoodsCollectionId: id}).then(response => {
	      if (response.data.success) {
	        setTimeout(() => {
			  this.getList()
          }, 500)
        }
      })
    },
	  onAdd () {
	    this.modal.form = {
		  title: '',
		  startTime: '',
		  endTime: '',
		  cardId: '',
		  bannerImage: '',
		  sort: ''
      }
      this.modal.visible = true
	  },
	  onCancel () {
      this.modal.visible = false
	  },
	  /**
       * 新增，编辑确认提交
	   */
	  onConfirm () {
	    let params = this.modal.form
      if (this.modal.mpGoodsCollectionId) {
	      params.mpGoodsCollectionId = this.modal.mpGoodsCollectionId
      }
      if (!this.onVerify()) {
        return false
      }
      HttpRequest.post('/admin.php?method=mpgoodscollection.doSave', params).then(response => {
        if (response.data.success) {
          this.modal.visible = false
          this.getList()
        }
      })
	  },
	  onVerify () {
      if (!this.modal.form.startTime || !this.modal.form.endTime) {
		  this.$message('请选择开始时间与结束时间')
		  return false
      } else if (!this.modal.form.cardId) {
		  this.$message('请填写卡片Id')
		  return false
      } else if (!this.modal.form.title) {
		  this.$message('请填写标题')
		  return false
      }
      return true
    },
	  onBlur (index) {
      let params = {
        sort: this.list[index].sort,
		  mpGoodsCollectionId: this.list[index].mpGoodsCollectionId
      }
      HttpRequest.post('/admin.php?method=mpgoodscollection.doSetSort', params).then(response => {
        if (response.data.success) {
          this.$message('排序号修改成功')
        }
      })
    }
  }
}
</script>
<style lang="less">
    .collection-list-container {
        .banner-uploader {
            display: inline-block;
        }
        .el-form-item__label {
            font-weight: bold;
        }
    }
</style>
